import { create } from 'zustand';
import shallow from 'zustand/shallow';

export * from './devtools';
export * from './immer';

export const createStore = create;
export const shallowEqual = shallow;
